module.exports = __webpack_public_path__ + "img/img_09_brand_retail@3x.2cf09cdd.png";